import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import {
  Button,
  Avatar,
  TextField,
  Paper,
  Typography,
  Grid
} from '@material-ui/core';
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import IconButton from "@material-ui/core/IconButton";
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {

  KeyboardDatePicker,
} from '@material-ui/pickers';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/DeleteOutlined';
import AddIcon from '@material-ui/icons/Add';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import { NetworkContext } from '../../../../context/NetworkContext';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  papercontent: {
      marginTop : theme.spacing(2),
      textAlign : 'center'
  },
  drawer: {
    width: 420,
    maxWidth: '100%'
  },
  descriptionfield: {
    width: '100%'
   
  },
  header: {
    padding: theme.spacing(2, 1),
    display: 'flex',
    justifyContent: 'space-between'
  },
  buttonIcon: {
    marginRight: theme.spacing(1)
  },
  content: {
    padding: theme.spacing(2, 3),
    flexGrow: 1
  },
  contentSection: {
    padding: theme.spacing(2, 0)
  },
  contentSectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    cursor: 'pointer'
  },
  contentSectionContent: {},
  formGroup: {
   
    padding: theme.spacing(1, 0)
  },
  fieldGroup: {
    display: 'flex',
    alignItems: 'center'
  },
  field: {
    marginTop: 0,
    marginBottom: 0
  },
  flexGrow: {
    flexGrow: 1
  },
  input: {
    display: 'none',
  },
  addButton: {
    marginLeft: theme.spacing(1)
  },
  tags: {
    marginTop: theme.spacing(1)
  },
  minAmount: {
    marginRight: theme.spacing(3)
  },
  maxAmount: {
    marginLeft: theme.spacing(3)
  },
  radioGroup: {},
  actions: {
    textAlign: 'right',
    padding: theme.spacing(3),
    paddingRight: theme.spacing(5),
    '& > * + *': {
      margin: theme.spacing(0)
    }
  }
}));

const ProductDetails = props => {
  const { open, onClose, onUpdate,usercontent,masters, viewtype, className, ...rest } = props;

  const classes = useStyles();
  const [basicInfo, setBasicInfo] = React.useState({});

  const produtoptions = {
    options:[
                
               
      {
        "id":1,
        "name":"Broker 1",
        "createdAt":"17 Nov 2022 10:20 AM",
        "status":true
      },
      {
        "id":2,
        "name":"Broker 2",
        "createdAt":"17 Nov 2022 10:20 AM",
        "status":true
      },
      {
        "id":3,
        "name":"Broker 3",
        "createdAt":"17 Nov 2022 10:20 AM",
        "status":true
      }
    ],
    getOptionLabel: (option) => option.name
  
  };
  const [actions, setActions] = useState([]);
  const [menus, setMenus] = useState([]);
  const [submenu, setSubmenu] = useState([]);
  const [actionmaster, setActionmaster] = useState([]);

  const [submenumaster, setSubmenumaster] = useState([]);
  const initialValues = {
    languages:['All','Tamil','English','Telugu'],
    nameenglish: '',
    nametamil:'',
    nametelugu:'',
    descenglish:'',
    desctamil:'',
    desctelugu:'',
    qty : '',
    producttype: {},
    imageurl:'',
    commodity: {},
    subcommodity : {}
  };
  const { sendNetworkRequest } = React.useContext(NetworkContext);

  const [expandProject, setExpandProject] = useState(true);
  const [expandCustomer, setExpandCustomer] = useState(false);
  const [subcommodity, setSubcommodity] = useState([]);

  const [values, setValues] = useState({
    ...initialValues
  });

  const handleClear = () => {
    setValues({ ...initialValues });
  };

  
  React.useEffect(() => {
    
    if(usercontent && usercontent.master_role)
    {
     
      setBasicInfo({
        ...basicInfo,
        "role" : usercontent.master_role
      })
      setMenus(
        usercontent.access_menu
      )
      fetchsubmenu(usercontent.access_menu)
      setSubmenu(usercontent.access_submenu)
      fetchactions(usercontent.access_submenu)
      setActions(usercontent.access_action)
    }
 }, [usercontent,masters]);

  // React.useEffect(() => {
  //  setSubmenu([])
  // }, [menus]);
  // React.useEffect(() => {
  //   setActions([])
  //  }, [submenu]);
  const handleFieldChange = (event, field, value) => {
    event.persist && event.persist();
    setValues(values => ({
      ...values,
      [field]: value
    }));
  };

  const handleTagAdd = () => {
    setValues(values => {
      const newValues = { ...values };

      if (newValues.tag && !newValues.tags.includes(newValues.tag)) {
        newValues.tags = [...newValues.tags];
        newValues.tags.push(newValues.tag);
      }

      newValues.tag = '';

      return newValues;
    });
  };

  const handleTagDelete = tag => {
    setValues(values => {
      const newValues = { ...values };

      newValues.tags = newValues.tags.filter(t => t !== tag);

      return newValues;
    });
  };

  const handleToggleProject = () => {
    setExpandProject(expandProject => !expandProject);
  };

  const handleToggleCustomer = () => {
    setExpandCustomer(expandCustomer => !expandCustomer);
  };

  const handleSubmit = event => {
    event.preventDefault();
    if(usercontent && usercontent.id)
    {
      basicInfo['id'] = usercontent.id;
    }
   
    basicInfo['menu'] = menus;
    basicInfo['submenu'] = submenu;
    basicInfo['actions'] = actions;
    onUpdate && onUpdate(basicInfo);
  };

  const paymentStatusOptions = ['Pending', 'Canceled', 'Completed', 'Rejected'];
  const customerAgeOption = ['18 - 30', '30 - 45', '50 - 60', '60+'];
  const handleChange = (event) => {
    if(event.target.value == 'All')
    {
      if(event.target.checked)
      {
        setValues(values => ({
          ...values,
          ['languages']: ['All','Tamil','English','Telugu']
        }));
      }else{
        setValues(values => ({
          ...values,
          ['languages']: []
        }));
      }
    }else{
      if(event.target.checked)
      {
        var array = [...values.languages]
        if(array.length === 2)
        {
          array.push('All')
        }
        array.push(event.target.value)
        setValues(values => ({
          ...values,
          ['languages']: array
        }));
      }else{
        var array = [...values.languages]; // make a separate copy of the array
         if(array.length > 1)
         {
          var allindex = array.indexOf('All')
          if(allindex !== -1)
          {
            array.splice(allindex, 1)
          }

          var index = array.indexOf(event.target.value)
          if (index !== -1) {
            array.splice(index, 1);
           
            setValues(values => ({
              ...values,
              ['languages']: array
            }));
          }
        }
      }
    }
    //setChecked(event.target.checked);
  };
  async function fetchsubmenu(modules)
  {
    let module_ids =[]
    modules.forEach(element => {
      module_ids.push(element.id)
    });
    let menu = await sendNetworkRequest('/admin/getmodules', {}, {type : 'submenu',modules:module_ids},false)
    
    setSubmenumaster(
     menu.module
    )

  }
  async function fetchactions(modules)
  {
    let module_ids =[]
    modules.forEach(element => {
      module_ids.push(element.id)
    });
    let menu = await sendNetworkRequest('/admin/getmodules', {}, {type : 'action',modules:module_ids},false)
    
    setActionmaster(
     menu.module
    )
  }
  const handleoptionchange = type => (event, value) => {
    if(type == 'menu')
    {
      setMenus(value)
      fetchsubmenu(value);
    }
    else if(type == 'submenu')
    {
      setSubmenu(value)
      fetchactions(value);
    }
   else if(type == 'action')
    {
      setActions(value)
      //fetchsubmenu();
    }else 
    {
      setBasicInfo({
        ...basicInfo,
        [type] : value
      })
    }
  }
  const handleremoveoption = type => (event, value) => {
    if(type == 'menu')
    {
      setMenus(value)
      fetchsubmenu();
    }
    else if(type == 'submenu')
    {
      setSubmenu(value)
      fetchactions();
    }
   else if(type == 'action')
    {
      setActions(value)
      //fetchsubmenu();
    }else 
    {
      setBasicInfo({
        ...basicInfo,
        [type] : value
      })
    }
  }
  const setData = async (value, name, fun, state) => {
    let url = null;
    let extra = {};
    if (name === "image") {
      url = await toBase64(value)
      extra = { [name + "url"]: url }
    }

    fun({
      ...state, [name]: value, ...extra
    })
  }

  const toBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });


  const handleinputchange = type => e => {
    setValues({
      ...values,
      [type]: e.target.value
    });
  }

  return (
  <Paper className={classes.papercontent}> 
      <form
        {...rest}
        className={clsx(classes.root, className)}
        onSubmit={handleSubmit}
      >
        
        <div className={classes.content}>
        <Grid container xs={12}>
        <Grid item xs={12}>
        {masters &&masters.roles != null ?   <Autocomplete
                    
                    id="combo-box-demo"
                    options={masters && masters.roles != null ? masters.roles : []}
                    margin="dense"
                    fullWidth
                    autoSelect
                    value={basicInfo.role && basicInfo.role}
                    disabled={viewtype == 2 ? true : false}
                    onChange={handleoptionchange('role')}
                    getOptionLabel={(option) => option.name}
                    renderInput={(params) => <TextField {...params} label={"Master Roles"} fullWidth margin="dense" variant="outlined" />}
                  />  : null}
        </Grid>
         {basicInfo.role && basicInfo.role.id != null ? <Grid container row xs={12} spacing={2}>
              
          <Grid container item xs={4}>
            <Grid item xs={12}>
                  <Autocomplete
                          options={masters && masters.menu != null ? masters.menu : []}
                          getOptionLabel={(option) => option.name}
                        multiple
                        id="combo-box-demo"
                        margin="dense"
                        fullWidth
                        filterSelectedOptions
                        value={menus}
                        getOptionSelected={(option, value) => option.name === value.name}
                       // onChange={(e, newValue) => setMenus(newValue)}
                        disabled={viewtype == 2 ? true : false}
                        renderTags={() => null}
                        onChange={handleoptionchange('menu')}
                        renderInput={(params) => <TextField {...params} label={"Menus"} fullWidth margin="dense" variant="outlined" />}
                      /> 
              </Grid>
                <Grid item xs={12}>
                            <List>
                            {menus.map((movie) => (
                              <ListItem key={movie.name}>
                                <ListItemText primary={movie.name} />
                                <IconButton
                                  key={movie.id}
                                  aria-label="delete"
                                  onClick={() => {
                                    setMenus(() => menus.filter((m) => m !== movie));
                                  }}
                                >
                                  <HighlightOffIcon />
                                </IconButton>
                              </ListItem>
                            ))}
                          </List>
                </Grid>
          </Grid> 
         {submenumaster && submenumaster.length > 0 && menus.length > 0 ? <Grid container item xs={4}>
           <Grid item xs={12}>
           
                  <Autocomplete

                        options={submenumaster != null ? submenumaster: []}
                        getOptionLabel={(option) => option.name}
                        multiple
                        id="combo-box-demo"
                        margin="dense"
                        fullWidth
                        filterSelectedOptions
                        value={submenu}
                        getOptionSelected={(option, value) => option.name === value.name}
                        
                        disabled={viewtype == 2 ? true : false}
                        renderTags={() => null}
                        onChange={handleoptionchange('submenu')}
                        renderInput={(params) => <TextField {...params} label={"Sub Menus"} fullWidth margin="dense" variant="outlined" />}
                      /> 
              </Grid>
                <Grid item xs={12}>
                            <List>
                            {submenu.map((movie) => (
                              <ListItem key={movie.name}>
                                <ListItemText primary={movie.name} />
                                <IconButton
                                  key={movie.id}
                                  aria-label="delete"
                                  onClick={() => {
                                    setSubmenu(() => submenu.filter((m) => m !== movie));
                                  }}
                                >
                                  <HighlightOffIcon />
                                </IconButton>
                              </ListItem>
                            ))}
                          </List>
                </Grid>
            </Grid> : null}
            {actionmaster && actionmaster.length > 0  && submenu.length > 0  ?    <Grid container item xs={4}>
             <Grid item xs={12}>
                  <Autocomplete

                        options={actionmaster != null ? actionmaster: []}
                        getOptionLabel={(option) => option.name}
                        multiple
                        id="combo-box-demo"
                        margin="dense"
                        fullWidth
                        filterSelectedOptions
                        value={actions}
                        getOptionSelected={(option, value) => option.name === value.name}
                        
                        disabled={viewtype == 2 ? true : false}
                        renderTags={() => null}
                        onChange={handleoptionchange('action')}
                        renderInput={(params) => <TextField {...params} label={"Actions"} fullWidth margin="dense" variant="outlined" />}
                      /> 
              </Grid>
                <Grid item xs={12}>
                            <List>
                            {actions.map((movie) => (
                              <ListItem key={movie.name}>
                                <ListItemText primary={movie.name} />
                                <IconButton
                                  key={movie.id}
                                  aria-label="delete"
                                  onClick={() => {
                                    setActions(() => actions.filter((m) => m !== movie));
                                  }}
                                >
                                  <HighlightOffIcon />
                                </IconButton>
                              </ListItem>
                            ))}
                          </List>
                </Grid>
            </Grid> : null
                                }
          
         
            
           
          
          
          </Grid> : null }
      
          </Grid>
        </div>
        <div className={classes.actions}>
          {/* <Button
            onClick={handleClear}
            variant="contained"
           
          >
            Clear
          </Button> */}
          <Button
            color="primary"
            type="submit"
            variant="contained"
            
          >
            Submit
          </Button>
        </div>
      </form>
      </Paper> 
  );
};

ProductDetails.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  onUpdate: PropTypes.func,
  open: PropTypes.bool.isRequired,
  masters: PropTypes.object
};

export default ProductDetails;
